var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navigation-menu-ctn",
    class: {
      'collapsed': _vm.isCollapsed,
      'is-mobile': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "nav-menu-header-ctn"
  }, [_c('div', {
    staticClass: "header-content",
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/products');
      }
    }
  }, [_c('scantrust-pro-logo-icon', {
    staticClass: "logo-icon",
    attrs: {
      "size": "32"
    }
  }), _c('scantrust-pro-text-icon', {
    staticClass: "text-logo",
    attrs: {
      "size": "115"
    }
  })], 1), !_vm.isMobile ? _c('div', {
    staticClass: "collapse-btn",
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-left'))])], 1) : _vm._e()]), _c('nav', {
    staticClass: "nav-list"
  }, [_c('div', {
    staticClass: "nav-items-container"
  }, [_c('div', {
    staticClass: "nav-item",
    class: {
      'active': _vm.isActive('/products')
    },
    attrs: {
      "title": _vm.isCollapsed ? _vm.$t('navigation_products') : ''
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/products');
      }
    }
  }, [_c('div', {
    staticClass: "nav-item-icon"
  }, [_c('product-icon', {
    attrs: {
      "color": _vm.isActive('/products') ? '#0070b6' : 'black'
    }
  })], 1), _c('div', {
    staticClass: "nav-item-title"
  }, [_vm._v(_vm._s(_vm.$t('navigation_products')))])]), _vm.totalCodesCount || _vm.usedCodesCount ? _c('div', {
    staticClass: "nav-item",
    class: {
      'active': _vm.isActive('/gallery')
    },
    attrs: {
      "title": _vm.isCollapsed ? _vm.$t('navigation_gallery') : ''
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/gallery');
      }
    }
  }, [_c('div', {
    staticClass: "nav-item-icon"
  }, [_c('gallery-icon', {
    attrs: {
      "color": _vm.isActive('/gallery') ? '#0070b6' : 'black'
    }
  })], 1), _c('div', {
    staticClass: "nav-item-title"
  }, [_vm._v(_vm._s(_vm.$t('navigation_gallery')))])]) : _vm._e(), _c('div', {
    staticClass: "nav-item",
    class: {
      'active': _vm.isActive('/')
    },
    attrs: {
      "title": _vm.isCollapsed ? _vm.$t('navigation_dashboard') : ''
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/');
      }
    }
  }, [_c('div', {
    staticClass: "nav-item-icon"
  }, [_c('dashboard-icon', {
    attrs: {
      "color": _vm.isActive('/') ? '#0070b6' : 'black'
    }
  })], 1), _c('div', {
    staticClass: "nav-item-title"
  }, [_vm._v(_vm._s(_vm.$t('navigation_dashboard')))])]), _c('div', {
    staticClass: "nav-item",
    class: {
      'active': _vm.isActive('/upgrade')
    },
    attrs: {
      "title": _vm.isCollapsed ? _vm.$t('navigation_plans') : ''
    },
    on: {
      "click": function ($event) {
        return _vm.navigateTo('/upgrade?source=menu');
      }
    }
  }, [_c('div', {
    staticClass: "nav-item-icon"
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.isActive('/upgrade') ? 'primary' : 'black'
    }
  }, [_vm._v("mdi-credit-card-outline")])], 1), _c('div', {
    staticClass: "nav-item-title"
  }, [_vm._v(_vm._s(_vm.$t('navigation_plans')))])])]), _c('div', {
    staticClass: "nav-profile-container"
  }, [_c('profile-navigation-btn', {
    attrs: {
      "is-collapsed": _vm.isCollapsed
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }